<script setup>
/**
 * Footer actions container for card buttons with configurable horizontal alignment.
 *
 * @status internal
 * @group cards-dialogs
 * @see https://quasar.dev/vue-components/card Quasar q-card-actions API
 */
defineOptions({ name: 'HrCardActions' });

defineProps({
  /**
   * Horizontal alignment of the action buttons.
   * @values left, center, right, between, around, evenly, stretch
   */
  align: {
    type: String,
    default: 'left',
    validator: (v) => ['left', 'center', 'right', 'between', 'around', 'evenly', 'stretch'].includes(v),
  },
});
</script>
<template>
  <q-card-actions
    :align="align"
    v-bind="$attrs"
  >
    <!-- @slot default Action buttons (e.g. HrBtn, HrDestructiveBtn) laid out per the `align` prop. -->
    <slot />
  </q-card-actions>
</template>
